<template>
  <div class="sel-modal clearfix">
    <div class="sel-modal-header clearfix">
      <div style="display: flex;align-items: center">
        <vxe-input style="height: 34px !important;border: 1px solid #dcdee2;" v-model="ordersNum" type="search"
                   placeholder="订单编号" @keyup.enter.native="search" @search-click="search"></vxe-input>
        <vxe-input style="height: 34px !important;border: 1px solid #dcdee2;margin-left: 20px;" v-model="carShipNum"
                   type="search"
                   placeholder="车船号" @keyup.enter.native="search" @search-click="search"></vxe-input>
        <vxe-input style="height: 34px !important;border: 1px solid #dcdee2;margin-left: 20px;" v-model="createUser"
                   type="search"
                   placeholder="创建人" @keyup.enter.native="search" @search-click="search"></vxe-input>
        <vxe-input style="height: 34px !important;border: 1px solid #dcdee2;margin-left: 20px;" v-model="createTime"
                   type="date" placeholder="创建时间" @keyup.enter.native="search" @search-click="search"></vxe-input>

        <Button type="primary" @click="search" icon="ios-search" style="margin-left: 10px;border-radius: 5px;">搜索
        </Button>
        <Button @click="reset" style="margin-left: 10px;border-radius: 5px;">重置</Button>
      </div>
    </div>
    <div>
      <vxe-table
          show-overflow
          stripe
          highlight-current-row
          highlight-hover-row
          border="none"
          ref="xGrid"
          class="table-style"
          max-height="430"
          align="center"
          :auto-resize="true"
          :data="tableData"
          :loading="loading"
          @sort-change="sortChangeEvent"
          @checkbox-all="selectAllEvent"
          @checkbox-change="selectChangeEvent"
      >
        <vxe-table-column type="checkbox" align="center" width="50"></vxe-table-column>
        <vxe-table-column field="ordersNum" title="订单编号" width="140"></vxe-table-column>
        <vxe-table-column field="goodsName" title="货物名称" width="105" show-overflow></vxe-table-column>
        <vxe-table-column field="goodsUnit" title="单位" width="60" show-overflow></vxe-table-column>
        <vxe-table-column field="realCount" title="实际数量" width="90" show-overflow></vxe-table-column>
        <vxe-table-column field="carShipNum" title="车船号" width="140" show-overflow></vxe-table-column>
        <vxe-table-column field="beginPlace" title="起运地" width="200" show-overflow></vxe-table-column>
        <vxe-table-column field="endPlace" title="目的地" width="200" show-overflow></vxe-table-column>
        <vxe-table-column field="beginTime" title="起运时间" width="140" remote-sort>
          <template slot-scope="{ row }">
            <span style="color: #a7adad">{{ row.beginTime | timeFormatDate}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="endTime" title="到达时间" width="140" remote-sort>
          <template slot-scope="{ row }">
            <span style="color: #a7adad">{{ row.endTime | timeFormatDate}}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="changePage"
      ></vxe-pager>
    </div>
    <div class="modal-footer add-btn-box" style="width: 98%;position: absolute;bottom: 0;padding:10px !important;">
      <Button type="primary" @click="commit">确 定</Button>
    </div>
  </div>
</template>

<script>

  import $api from "@/apiProvider";
  import moment from "moment";

  export default {
    name: "RelationLogistics",
    data() {
      return {
        page: {
          currentPage: 1,
          pageSize: 10,
          totalResult: 100,
        },
        tableData: [],
        loading: false,
        ordersNum: null,
        carShipNum: null,
        createUser: null,
        createTime: null,
        orderBy: 6,
        isDesc: null,
        records: []
      }
    },
    methods: {
      sortChangeEvent(sort) {
        if (sort.order == null) {
          this.orderBy = 6
          this.isDesc = null
        } else {
          this.isDesc = sort.order === 'desc' ? 1 : 0
          if (sort.field === 'beginTime') {
            this.orderBy = 4;
          }
          if (sort.field === 'endTime') {
            this.orderBy = 5;
          }
        }
        this.queryNoRelOrders();
      },
      reset() {
        this.ordersNum = null;
        this.carShipNum = null;
        this.createUser = null;
        this.createTime = null;
      },
      init(id) {
        this.id = id;
        this.queryNoRelOrders();
      },
      async queryNoRelOrders() {
        this.loading = true;
        let res = await $api.logisticsTwo.post('rel/queryNoRelOrders', {
          page: this.page.currentPage,
          rows: this.page.pageSize,
          orderBy: this.orderBy,
          isDesc: this.isDesc,
          ordersNum: this.ordersNum ? this.ordersNum : null,
          carShipNum: this.carShipNum ? this.carShipNum : null,
          createUser: this.createUser ? this.createUser : null,
          createTimeBegin: this.createTime ? moment(this.createTime).valueOf() : null,
          createTimeEnd: this.createTime ? moment(this.createTime).valueOf() + 86399999 : null,
          idNotInList: [this.id]
        });
        this.loading = false;
        if (res.status === 1) {
          this.page.totalResult = res.data.total;
          this.tableData = res.data.rows;
          this.tableData.map((i) => {
            this.records.map((j) => {
              if (i.id === j.id) {
                this.$refs.xGrid.setCheckboxRow(i, true);
              }
            });
          });
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      commit() {
        if (this.records.length === 0) {
          this.$XModal.alert({
            message: '请选择关联物流',
            status: "error",
          });
          return
        } else {
          this.addSubOrderIds();
        }
      },
      async addSubOrderIds() {
        let idList = [];
        this.records.map(i => {
          idList.push(i.id);
        })
        let res = await $api.logisticsTwo.post('rel/addSubOrderIds', {
          ordersId: this.id,
          relIdList: idList
        });
        if (res.status === 1) {
          this.$Message.success("关联成功");
          this.records = [];
          this.$emit('afterSave');
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      close() {
        this.records = [];
      },
      search() {
        this.queryNoRelOrders();
      },
      changePage(e) {
        this.page.currentPage = e.currentPage;
        this.page.pageSize = e.pageSize;
        this.queryNoRelOrders();
      },
      selectChangeEvent({checked, row}) {
        if (checked) {
          this.records.push(row);
        } else {
          let key = this.records.indexOf(row);
          this.records.splice(key, 1);
        }
      },
      selectAllEvent({checked, records}) {
        if (checked) {
          this.records = records;
        } else {
          this.records = [];
        }
      },
    }
  }
</script>
<style>

</style>